import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  listingContainer: {
    marginTop: '2.5rem'
  },
  card: {
    padding: '2rem',
    marginBottom: '2rem'
  },
  cardTitle: {
    ...theme.typography.title_smallBold
  },
  rowDate: {
    textTransform: 'uppercase'
  },
  row: {
    border: `2px solid ${theme.palette.focus20.main}`,
    borderRadius: '4px',
    padding: '1rem',
    margin: '4px 0px 8px 0px',
    '& p:first-child': {
      textTransform: 'capitalize'
    },
    [theme.breakpoints.up('md')]: {
      padding: '2rem'
    }
  },
  pill: {
    marginTop: '0px',
    marginLeft: '1rem',
    backgroundColor: theme.palette.peace10.main,
    borderRadius: '1rem',
    padding: '6px 14px'
  }
}));

export default useStyles;
